import { TourAPIStrategy } from '../types/OnboardingTour';
import { PLACEMENT } from '../types/Placement';
import { toArrowPlacement } from '../utils/toArrowPlacement';
export const GH_BOOKMARKS_Q2_2025_TOUR_ID = 'gh-bookmarks-q2-2025-tour';
const GH_BOOKMARKS_Q2_2025_TOUR_STEPS = [{
  title: {
    key: 'app.tours.gh_bookmarks_q2_2025.step_1.title'
  },
  description: {
    key: 'app.tours.gh_bookmarks_q2_2025.step_1.description'
  },
  targetSelector: '[id="global-home"]',
  placement: PLACEMENT.RIGHT_BOTTOM,
  arrowPosition: toArrowPlacement(PLACEMENT.RIGHT_BOTTOM),
  offset: {
    top: 0,
    left: 10
  }
}, {
  title: {
    key: 'app.tours.gh_bookmarks_q2_2025.step_2.title'
  },
  description: {
    key: 'app.tours.gh_bookmarks_q2_2025.step_2.description'
  },
  targetSelector: {
    overrideId: 'primary-menu-item',
    selector: '[data-onboarding-hook="primary-menu"]'
  },
  placement: PLACEMENT.RIGHT,
  arrowPosition: toArrowPlacement(PLACEMENT.RIGHT),
  offset: {
    top: 0,
    left: 10
  }
}];
export const GH_BOOKMARKS_Q2_2025_TOUR = {
  id: GH_BOOKMARKS_Q2_2025_TOUR_ID,
  apiStrategy: TourAPIStrategy.NAV_PERSONA_PORTAL_PLUS_USER_BASED,
  steps: GH_BOOKMARKS_Q2_2025_TOUR_STEPS
};